type TFormProps = {
  name: string;
  label?: string;
  type?: string;
  placeholder?: string;
  value?: any;
  readOnly?: boolean;
  onChange?: (e: any) => void;
  onInput?: (e: any) => void;
  isTextArea?: boolean;
  required?: boolean;
  className?: string;
  disabled?: boolean;
  hero?: boolean;
  maxLength?: number;
  inputMode?: "none" | "text" | "numeric" | "tel" | "email";
  autoComplete?: string;
};

const FormInput = ({
  name,
  label,
  type = "text",
  placeholder,
  value,
  readOnly,
  onChange,
  onInput,
  isTextArea = false,
  required = false,
  disabled,
  hero,
  maxLength,
  inputMode,
  autoComplete,
  className = "",
}: TFormProps) => {
  const InputComponent = isTextArea ? "textarea" : "input";

  const inputProps = {
    name,
    type,
    value,
    onChange,
    onInput,
    placeholder,
    required,
    hero,
    disabled,
    maxLength,
    inputMode,
    autoComplete,
    ...(type === "number" && {
      min: 0,
    }),
    ...(type === "date" && {
      min: new Date().toISOString().split("T")[0],
    }),
    className: `
      w-full
      px-4
      py-3
      ${hero ? "text-white" : "text-gray-600"}
      ${hero ? "bg-transparent" : "bg-white"}
      shadow-sm
      border
      border-soft-200
      rounded-lg
      focus:outline-none
      focus:border-bnp-cyan
      transition-colors
      ${isTextArea ? "min-h-[160px] resize-none" : "h-12"}
      ${className}
    `,
  };

  return (
    <div className={`${hero ? "" : "mb-2"}`}>
      {label && (
        <label
          className={`block ${
            hero ? "text-white font-semibold" : "text-blue-primary"
          }  font-medium text-sm ${hero ? "mb-1" : "mb-2"} `}
        >
          {label} {required && <span className="text-red-500 text-sm">*</span>}
        </label>
      )}
      <InputComponent {...inputProps} />
    </div>
  );
};

export default FormInput;
